/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_PauseInputs */

const cs_sklik_pause = /** @type {(inputs: Sklik_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozastavit`)
};

const en_sklik_pause = /** @type {(inputs: Sklik_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause`)
};

/**
* | output |
* | --- |
* | "Pause" |
*
* @param {Sklik_PauseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_pause = /** @type {((inputs?: Sklik_PauseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_PauseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_pause(inputs)
	return cs_sklik_pause(inputs)
});